import type { CampaignScheduleKind } from '@workspace/types';

export type CampaignScheduleState = {
  scheduleKind: CampaignScheduleKind;
  weekdayEnabled: boolean;
  weekdayFrom: string;
  weekdayTo: string;
  weekdayAfternoonFrom: string;
  weekdayAfternoonTo: string;
  saturdayEnabled: boolean;
  saturdayFrom: string;
  saturdayTo: string;
  saturdayAfternoonFrom: string;
  saturdayAfternoonTo: string;
  sundayEnabled: boolean;
  sundayFrom: string;
  sundayTo: string;
  sundayAfternoonFrom: string;
  sundayAfternoonTo: string;
  holidays: string[];
};

export const DEFAULT_CAMPAIGN_SCHEDULE: CampaignScheduleState = {
  scheduleKind: 'URBANO',
  weekdayEnabled: true,
  weekdayFrom: '09:00',
  weekdayTo: '18:00',
  weekdayAfternoonFrom: '16:00',
  weekdayAfternoonTo: '20:00',
  saturdayEnabled: false,
  saturdayFrom: '09:00',
  saturdayTo: '13:00',
  saturdayAfternoonFrom: '16:00',
  saturdayAfternoonTo: '20:00',
  sundayEnabled: false,
  sundayFrom: '09:00',
  sundayTo: '13:00',
  sundayAfternoonFrom: '16:00',
  sundayAfternoonTo: '20:00',
  holidays: [],
};

export function schedulePayload(state: CampaignScheduleState) {
  const rural = state.scheduleKind === 'RURAL';
  return {
    weekdayEnabled: state.weekdayEnabled,
    scheduleKind: state.scheduleKind,
    scheduleFrom: state.weekdayFrom,
    scheduleTo: state.weekdayTo,
    afternoonFrom: rural && state.weekdayEnabled ? state.weekdayAfternoonFrom : null,
    afternoonTo: rural && state.weekdayEnabled ? state.weekdayAfternoonTo : null,
    saturdayFrom: state.saturdayEnabled ? state.saturdayFrom : null,
    saturdayTo: state.saturdayEnabled ? state.saturdayTo : null,
    saturdayAfternoonFrom: rural && state.saturdayEnabled ? state.saturdayAfternoonFrom : null,
    saturdayAfternoonTo: rural && state.saturdayEnabled ? state.saturdayAfternoonTo : null,
    sundayFrom: state.sundayEnabled ? state.sundayFrom : null,
    sundayTo: state.sundayEnabled ? state.sundayTo : null,
    sundayAfternoonFrom: rural && state.sundayEnabled ? state.sundayAfternoonFrom : null,
    sundayAfternoonTo: rural && state.sundayEnabled ? state.sundayAfternoonTo : null,
    holidays: state.holidays,
  };
}
